/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    string, shape, number, object,
    func,
} from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { useDispatch } from 'react-redux';

import ComponentErrorBoundary from '../../../EnterpriseID/Common/ComponentErrorBoundary/ComponentErrorBoundary';
import CarouselBuilderSkeleton from '../../../GraphqlSkeletonComponents/CarouselBuilderSkeleton';
import PersonalizedHPCarouselBuilder from '../PersonalizedHomePageCarouselBuilder/PersonalizedHomePageCarouselBuilder';
import useSalesforceDerivedReminderRecsQuery from '../../../../../helpers/Personalization/useSalesforceDerivedReminderRecsQuery';
import useSalesforceBuyItAgainRecsQuery from '../../../../../helpers/Personalization/useSalesforceBuyItAgainRecsQuery';
import useClickStreamCustomEventsTracking from '../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';
import { emitProductImpression, emitCustomTrackingEvent } from '../../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import PersonalizedHPGridUI from '../PersonalizedHomePageGridUI/PersonalizedHomePageGridUI';
import DerivedReminderRecsBuilder from './DerivedReminderRecsBuilder';

const DerivedRemindersSFContainer = ({
    data, productsToShow, customerRecsFallbackTitle = 'Recently Viewed Products', setShowSkeleton,
}) => {
    const renderDerivedReminderRecs = (recipients) => {
        let structuredSFData = null;
        const derivedReminderRecsComponents = recipients?.map((recipient) => {
            structuredSFData = {
                derivedReminderRecs: {
                    productRecs: recipient?.productRecs, productRecsContent: { ...data?.derivedReminderRecs?.productsContent, name: recipient?.name, main_title: recipient?.dynamicHeader }, campaign: data?.derivedReminderRecs?.campaign,
                },
            };
            return (<DerivedReminderRecsBuilder data={structuredSFData} products_to_show={productsToShow} customerRecsFallbackTitle={customerRecsFallbackTitle} recommendationsType="derivedReminderRecs" setShowSkeleton={setShowSkeleton} />);
        });
        return derivedReminderRecsComponents;
    };

    if (data?.derivedReminderRecs?.recipients && data?.derivedReminderRecs?.recipients.length > 0) {
        return renderDerivedReminderRecs(data?.derivedReminderRecs?.recipients);
    }
    return null;
};

DerivedRemindersSFContainer.propTypes = {
    data: object.isRequired,
    productsToShow: string.isRequired,
    customerRecsFallbackTitle: string.isRequired,
    setShowSkeleton: func.isRequired,
};

export default DerivedRemindersSFContainer;
